import { createAction, props } from '@ngrx/store';

/**
 * Payment Token Feature Actions
 *
 * These actions support payment token initialization flow:
 * - External site provides token
 * - Frontend extracts token data via API
 * - State populated from token payload
 * - User navigated to payment page
 */

// Customer ID Management (NEW)
export const setCustomerId = createAction('[Payment Token] Set Customer ID', props<{ customerId: string }>());

// Route Parameters Management (NEW)
export const setRouteParams = createAction(
    '[Payment Token] Set Route Params',
    props<{
        contractIds: string[];
        contractCustomerId: string;
        amount?: number;
    }>()
);

// Authentication Management (NEW)
export const setAuth = createAction(
    '[Payment Token] Set Auth',
    /* eslint-disable @typescript-eslint/naming-convention */
    props<{
        AccessToken: string;
        RefreshToken: string | null;
        Email: string;
    }>()
);

// Navigation Management (NEW)
export const setRouteTo = createAction(
    '[Payment Token] Set Route To',
    props<{
        route: string;
        routeParams: {
            contractIds: string[];
            contractCustomerId: string;
            amount?: number;
        };
    }>()
);
